import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getVisibleSlides, getCustomWidths } from './helpers';
import { ScrollFlex } from './SlideBox.styled';
import { Slide } from './Slide';
import { SlideBoxWrapper } from './SlideBoxWrapper';
import { TopArrows } from './TopArrows';
import { BottomArrows } from './BottomArrows';
import { useSlideBoxNav } from './useSlideBoxNav';
const SlideBox = ({ children, visibleSlides, onSlideChange, slideSpacing, stretchHeight, layout, currentSlideOverride, arrowSizeOverride, arrowButtonVariation = 'white', arrowPosition = 'hide', slideScrollNum = 2, mobileSlideScrollNum = 1, }) => {
    const childArray = React.Children.toArray(children);
    const ref = useRef();
    const { setCurrentSlide, currentSlide, onSlideChangeWrapper, arrowProps } = useSlideBoxNav({
        onSlideChange,
        currentSlideOverride,
        arrowSizeOverride,
        arrowButtonVariation,
        arrowPosition,
        childArray,
        slideScrollNum,
        mobileSlideScrollNum,
    });
    useEffect(() => {
        setCurrentSlide(currentSlideOverride);
    }, [currentSlideOverride]);
    return (React.createElement(SlideBoxWrapper, { alignItems: 'center', arrowPosition: arrowPosition },
        React.createElement(TopArrows, { arrowProps: arrowProps, arrowPosition: arrowPosition }),
        React.createElement(ScrollFlex, { width: '100%', py: 2, "data-testid": 'slide-box', ref: ref }, childArray.map((item, index) => (React.createElement(Slide, { key: item.props.key || `slide${index}`, width: layout ? getCustomWidths(layout.split('-'), index) : getVisibleSlides(visibleSlides), onSlideChange: onSlideChangeWrapper, slideSpacing: slideSpacing, stretchHeight: stretchHeight, index: index, content: item, isCurrentSlide: currentSlide === index, numSlides: childArray.length, slideBoxRef: ref })))),
        React.createElement(BottomArrows, { arrowProps: arrowProps, arrowPosition: arrowPosition })));
};
//SlideBox props
SlideBox.propTypes = {
    children: PropTypes.node,
    visibleSlides: PropTypes.oneOf([PropTypes.array, PropTypes.humber]),
    onSlideChange: PropTypes.func,
    slideSpacing: PropTypes.number,
    stretchHeight: PropTypes.bool,
    layout: PropTypes.string,
    currentSlideOverride: PropTypes.number,
    arrowSizeOverride: PropTypes.string,
    arrowButtonVariation: PropTypes.string,
    arrowPosition: PropTypes.oneOf(['top', 'bottom', 'side', 'hide', undefined]),
    slideScrollNum: PropTypes.num,
    mobileSlideScrollNum: PropTypes.num,
};
export { SlideBox };
//# sourceMappingURL=SlideBox.js.map